var _circle, _circle2, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstantDeliveryReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FFECEF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 9,
    stroke: "#FF8296",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 20v4h2",
    stroke: "#FF8296",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 34l2-2M32 34l-2-2",
    stroke: "#FF8296",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.83 16A3.001 3.001 0 1016 19.83M28.17 16A3.001 3.001 0 1132 19.83",
    stroke: "#FF8296",
    strokeWidth: 2
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNGRkVDRUYiLz4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iOSIgc3Ryb2tlPSIjRkY4Mjk2IiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTI0IDIwVjI0SDI2IiBzdHJva2U9IiNGRjgyOTYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNiAzNEwxOCAzMiIgc3Ryb2tlPSIjRkY4Mjk2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMzIgMzRMMzAgMzIiIHN0cm9rZT0iI0ZGODI5NiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTE5LjgyOTMgMTZDMTkuNDE3NSAxNC44MzQ4IDE4LjMwNjIgMTQgMTcgMTRDMTUuMzQzMSAxNCAxNCAxNS4zNDMxIDE0IDE3QzE0IDE4LjMwNjIgMTQuODM0OCAxOS40MTc1IDE2IDE5LjgyOTMiIHN0cm9rZT0iI0ZGODI5NiIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0yOC4xNzA3IDE2QzI4LjU4MjUgMTQuODM0OCAyOS42OTM4IDE0IDMxIDE0QzMyLjY1NjkgMTQgMzQgMTUuMzQzMSAzNCAxN0MzNCAxOC4zMDYyIDMzLjE2NTIgMTkuNDE3NSAzMiAxOS44MjkzIiBzdHJva2U9IiNGRjgyOTYiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";
export { SvgInstantDeliveryReport as ReactComponent };